import { createFileRoute } from '@tanstack/react-router';

import { ChartLab } from '@/components/charts/dev/ChartLab';

export const Route = createFileRoute('/$market/chart-lab')({
  component: ChartLab,
});
